import { createAsyncReducer } from '../../standard-actions/reducers';
import {
    ILoadTicketActivitiesAction,
    ILoadTicketActivitiesSuccessAction,
    ILoadTicketActivitiesErrorAction
} from '../actions/ticket-details/load-ticket-activity';
import { ITicketsState } from '../state';
import { initialState } from './initial-state';

export type TicketsAction
    = ILoadTicketActivitiesAction
    | ILoadTicketActivitiesSuccessAction
    | ILoadTicketActivitiesErrorAction;

const init = (state: ITicketsState, action: TicketsAction) => ({
    ...state,
    ticketActivities: {
        ...initialState.ticketActivities,
        status: action.status,
        isRefresh: (action as ILoadTicketActivitiesAction).isRefresh
    }
});

const success = (state: ITicketsState, action: TicketsAction) => ({
    ...state,
    ticketActivities: {
        ...initialState.ticketActivities,
        status: action.status,
        items: (action as ILoadTicketActivitiesSuccessAction).data.items,
        pagination: (action as ILoadTicketActivitiesSuccessAction).data.pagination,
        isRefresh: (action as ILoadTicketActivitiesSuccessAction).isRefresh,
    }
});

const failure = (state: ITicketsState, action: TicketsAction) => ({
    ...state,
    ticketActivities: {
        ...initialState.ticketActivities,
        status: action.status,
        error: (action as ILoadTicketActivitiesErrorAction).error,
        isRefresh: (action as ILoadTicketActivitiesErrorAction).isRefresh
    }
});

const reset = (state: ITicketsState, action: TicketsAction) => ({
    ...state,
    ticketActivities: {
        ...initialState.ticketActivities,
        status: action.status,
    }
});

export const ticketActivitiesReducer = createAsyncReducer(initialState, init, success, failure, reset);
